import { root_props } from '../main';
import {getLocalObj, setLocalObj} from "./storage.ts";


export const product_list = [{
    avatar: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a9/75/49/a9754927-90b8-7774-c160-e592635761c9/AppIcon-0-0-1x_U007epad-0-1-0-0-85-220.png/246x0w.webp",
    name: "Classic Jigsaw",
    key: "classic"
}, {
    avatar: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/68/91/16/6891162f-c636-1d09-16a6-23851029088d/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/246x0w.webp",
    name: "Countryside Jigsaw",
    key: "countryside"
}]

export function getProductList() {
    return product_list
}

export function getProduct() {
    if (root_props.product) {
        return root_props.product
    } else {
        let product = getLocalObj('product', null);
        if (!product) {
            product = product_list[0]
            setLocalObj('product', product)
        }
        root_props.product = product
        return root_props.product
    }
}

export function changeProduct(p) {
    root_props.product = p
    setLocalObj('product', p);
    return root_props.product
}
